"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var country_1 = tslib_1.__importDefault(require("./country"));
var CurrencyResource = /** @class */ (function (_super) {
    tslib_1.__extends(CurrencyResource, _super);
    function CurrencyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CurrencyResource.endpoint = '/currencies';
    CurrencyResource.MODEL_NAME = 'currency';
    CurrencyResource.related = {
        country: country_1.default,
    };
    return CurrencyResource;
}(base_1.default));
exports.default = CurrencyResource;
//# sourceMappingURL=currency.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/currency.js
// module id = m8Fb
// module chunks = 0